export default __webpack_public_path__ + "static/media/frame-card-elder.0bf03350.png";